export default {
    settings_title: "Settings",
    toggle_dark_theme: "Dark Theme",
    frequent_questions: "Frequent Questions",
    about_us: "About",
    license: "License",
    app_manual: "App Manual",
    share_app: "Share this App",
    gitlab_contribute: "Contribute to our Projects",
    settings_close: "Close",
    change_language: "Change Language",
    choose_department: "Choose Department",
    form_feedback: "Give us your feedback"
}